module.exports = __webpack_public_path__ + "img/404.26fe7971.png";